import { render, staticRenderFns } from "./OverviewText.vue?vue&type=template&id=122cfc83&"
import script from "./OverviewText.vue?vue&type=script&lang=js&"
export * from "./OverviewText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports